exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".legend{display:inline-block;padding:10px;border:1px dotted #ccc;border-radius:2px}.legend .bar{border:1px solid green;border-radius:2px;height:10px;width:50px;display:inline-block;margin-left:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-76be2c05","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/compo/task/TaskSymb.vue
// module id = 4645
// module chunks = 0